import { OverlayRef } from "@angular/cdk/overlay";
import { CameraConviteContexto } from "app/camera/camera-contexto";

export abstract class AbCamera {
  abstract open(): Promise<string>;
  abstract openConvite(contexto?: CameraConviteContexto): Promise<string>;
  abstract createOverlay(): OverlayRef;
}
